import { ActiveCampaign } from '../translations-types';

const translations: ActiveCampaign = {
  title: 'ActiveCampaign',
  description:
    'Connect this location to ActiveCampaign. Per-questionnaire syncing is configured on the questionnaire itself (below the public link).',
  questionnaireSectionTitle: 'ActiveCampaign sync',
  configSaved: 'Configuration saved',
  connected: 'Connected',
  notConnected: 'Not connected',
  connect: 'Connect',
  disconnect: 'Disconnect',
  connectSuccess: 'Connected to ActiveCampaign',
  disconnectSuccess: 'Disconnected from ActiveCampaign',
  accountUrl: 'Account URL',
  accountUrlHelp: 'The API URL from ActiveCampaign → Settings → Developer (e.g. https://your-account.api-us1.com).',
  apiKey: 'API key',
  configsTitle: 'Questionnaire configurations',
  addConfig: 'Add',
  questionnaire: 'Questionnaire',
  list: 'List',
  tag: 'Tag',
  triggerScope: 'Trigger',
  scopeAll: 'All completions',
  scopePublicOnly: 'Public link only',
  enabled: 'Enabled',
  noConfigs: 'No configurations yet',
  configAdded: 'Configuration added',
  selectQuestionnaire: 'Choose a questionnaire',
  selectList: 'Choose a list',
  tagPlaceholder: 'Tag',
};

export default translations;
